 export const mainLinksArray: string[] = [
    'startPage','about','experience','skills','gallery','contact' ];

     export const galleryLinksArray: string[] = [
    'startPage','about','experience','skills','gallery','contact' ];